/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 data is checked against the official results after every Grand Prix; mismatches are corrected within hours.`)
};

const es_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los datos de F1 se comprueban contra los resultados oficiales después de cada Gran Premio; los errores se corrigen en cuestión de horas.`)
};

const de_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1-Daten werden nach jedem Grand Prix mit den offiziellen Ergebnissen abgeglichen; Abweichungen werden innerhalb weniger Stunden korrigiert.`)
};

const nl_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1-gegevens worden na elke Grand Prix gecontroleerd aan de hand van de officiële resultaten; afwijkingen worden binnen enkele uren gecorrigeerd.`)
};

const fr_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les données F1 sont vérifiées par rapport aux résultats officiels après chaque Grand Prix ; les écarts sont corrigés en quelques heures.`)
};

const it_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I dati F1 vengono verificati rispetto ai risultati ufficiali dopo ogni Gran Premio; le discrepanze vengono corrette entro poche ore.`)
};

const pt_br2_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dados de F1 são verificados em relação aos resultados oficiais após cada Grande Prêmio; divergências são corrigidas em poucas horas.`)
};

const pt_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dados de F1 são verificados em relação aos resultados oficiais após cada Grande Prémio; as discrepâncias são corrigidas em poucas horas.`)
};

const ja_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1データは各グランプリ後に公式結果と照合され、不一致は数時間以内に修正されます。`)
};

const zh_about_verify_li3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 数据会在每场大奖赛后与官方结果核对；如有差异，会在数小时内更正。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_verify_li3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_verify_li3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_verify_li3", locale)
	if (locale === "en") return en_about_verify_li3(inputs)
	if (locale === "es") return es_about_verify_li3(inputs)
	if (locale === "de") return de_about_verify_li3(inputs)
	if (locale === "nl") return nl_about_verify_li3(inputs)
	if (locale === "fr") return fr_about_verify_li3(inputs)
	if (locale === "it") return it_about_verify_li3(inputs)
	if (locale === "pt-BR") return pt_br2_about_verify_li3(inputs)
	if (locale === "pt") return pt_about_verify_li3(inputs)
	if (locale === "ja") return ja_about_verify_li3(inputs)
	return zh_about_verify_li3(inputs)
};